module.exports = {"540502001":"泽当街道","540502101":"昌珠镇","540502200":"亚堆乡","540502201":"索珠乡","540502202":"多颇章乡","540502203":"结巴乡","540502204":"颇章乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540502.json
// module id = 2859
// module chunks = 0